module.exports = __webpack_public_path__ + "img/party_popper.a49e59bc.png";